import firebase from "firebase/app";
import { _firebaseConfig } from "../consts";

import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

export const firebaseApp = firebase.initializeApp(_firebaseConfig);
export const db = firebaseApp.firestore()
export const firestore = db

export const Auth = firebase.auth();

// Collections
export const Users = firestore.collection("usuarios");
export const Clients = firestore.collection("clientes");
export const asig_perito = firestore.collection("asig_perito");
export const asig_asignacion = firestore.collection("asig_asignacion");
export const Requests = firestore.collection("Solicitudes");
export const Experts = firestore.collection("peritos");
export const Assignments = firestore.collection("asignaciones");

export const storageRef = firebase.storage().ref()

export { firebase }